export default {
  development: 'dev-godaddy',
  test: 'test-godaddy',
  local: 'dev-godaddy',
  production: 'godaddy'
};
